import request from '@wearetla/tla-essentials-tools/utilities/request';
import CreditCards from 'creditcards';
import { createI18nInstance } from '/utilities/i18n';

// Functions
import getCardTypeImage from '/functions/get-card-type-image';

import walletServices from '/services/wallet';

const getT = () => createI18nInstance().t;

const paymentServices = {
	getSavedCards: () => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get(`user/card`, {}, (payload, status, request) => {
				if (status === 200 && payload?.credit_cards) {
					resolve(
						[...payload.credit_cards].map((card) => {
							const bin = card.card_masked_number.split('*')[0];
							const cardType = CreditCards.card.type(bin.replace(/}D/g, ''), true);
							return {
								...card,
								value: card.uuid,
								label: card.card_masked_number,
								bin,
								type: cardType,
								typeImage: getCardTypeImage(cardType),
							};
						})
					);
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('Kayıtlı kartlar getirilirken bir hata ile karşılaşıldı.')
					);
				}
			});
		});
	},
	removeSavedCard: (cardId) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.post(`user/card/delete/${cardId}`, {}, (payload, status, request) => {
				if (status === 200) {
					resolve(request?.data?.meta?.messages || { success: t('Kartın başarıyla silindi.') });
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('Kartın silinirken bir hata ile karşılaşıldı, lütfen tekrar dene.')
					);
				}
			});
		});
	},
	makePayment: walletServices.makePayment,
};

export default paymentServices;
